import { Grid } from '@mui/material';
import { BoardType, ParamsPanelProps } from 'Types';

import MaterialPatternInput from 'designer/MaterialPatternInput';
import NumberInput from 'designer/NumberInput';

function ChevronParamsPanel(props: ParamsPanelProps<BoardType.Chevron>) {
  const { params, selection, onParamChange, onSelectionChange, units } = props;

  return (
    <Grid container direction="column" spacing={2}>
      <Grid container item spacing={2} wrap="nowrap">
        <Grid item xs={3}>
          <NumberInput
            id="row-height"
            label="Row Height"
            step={1 / 8}
            value={params.rowHeight}
            onChange={onParamChange('rowHeight')}
          />
        </Grid>
        <Grid item xs={3}>
          <NumberInput
            id="number-of-rows"
            label="# of Rows"
            value={params.numRows}
            onChange={onParamChange('numRows')}
          />
        </Grid>
        <Grid item xs={3}>
          <NumberInput
            id="rotation"
            label="Rotation"
            max={60}
            value={params.rotate}
            onChange={onParamChange('rotate')}
          />
        </Grid>
        <Grid item xs={3}>
          <NumberInput
            id="thickness"
            label="Thickness"
            step={1 / 8}
            value={params.thickness}
            onChange={onParamChange('thickness')}
          />
        </Grid>
      </Grid>

      <Grid item>
        <MaterialPatternInput
          id="pattern"
          onChange={onParamChange('pattern')}
          onSelectionChange={onSelectionChange}
          previewHeight={params.rowHeight}
          rotate={params.rotate}
          selection={selection}
          units={units}
          value={params.pattern}
        ></MaterialPatternInput>
      </Grid>
    </Grid>
  );
}

export default ChevronParamsPanel;
